import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SelectedMediaStore {
  selectedImageUrl: string | null;
  selectedMediaInferenceId: number | null;
  setSelectedImage: (url: string | null, mediaInferenceId?: number | null) => void;
  clearSelectedImage: () => void;
}

export const useSelectedMediaStore = create<SelectedMediaStore>()(
  persist(
    (set) => ({
      selectedImageUrl: null,
      selectedMediaInferenceId: null,
      setSelectedImage: (url, mediaInferenceId = null) =>
        set({ selectedImageUrl: url, selectedMediaInferenceId: mediaInferenceId }),
      clearSelectedImage: () => set({ selectedImageUrl: null, selectedMediaInferenceId: null }),
    }),
    {
      name: 'selected-media-storage',
    },
  ),
);
